export const fileTypes = {
	userAvatar: 1,
	productImage: 2
};

export const IMAGE_NAME = 'image.jpeg';
export const IMAGE_TYPE = 'image/jpeg';